import { TextField, makeStyles } from '@material-ui/core';
import {
    BuildFieldUploadMessage,
    buildLiveChatMessageFromMe,
    buildMessageConnecting,
    postMessage,
    postMessageLiveChat
} from '../handler/ChatBoxHandler';
import { Autocomplete } from '@material-ui/lab';
import { I18n } from 'aws-amplify';
import React from 'react';
import OverFlowTooltipWithTabsMui from '@/component/common/OverFlowTooltipWithTabsMui';
import { useState, useEffect } from 'react';
import { IconButton } from '@material-ui/core';
import Utils from '@/common/utils/utils';
import { onSubmitUploadFile } from './handler/LiveChatHandler';
import Constant from '@/common/constant/Constant';
export default function ChatBotInput({
    chatbotSettings,
    listOptionsAutocomplete,
    onChangeOptionsAutocomplete,
    selectedOfOptions,
    setMessages,
    isActivateLiveChat,
    supportTicketId,
    supportThreadId,
    affiliationOrganization,
    setFileUploadList,
    affiliationProject,
    setFileUploading,
    setSentMessageList,
    isModePreview,
    API
}) {
    const [isDisableBtnSend, setIsDisableBtnSend] = useState(true);
    const [messageValue, setMessageValue] = useState('');
    // const [isSendDone, setIsSendDone] = useState(false);

    useEffect(() => {
        const chatPost = messageValue.trim();
        if (chatPost?.length < 1) {
            // Checking the length of the input
            setIsDisableBtnSend(true); // Disabling the button if length is < 1
        } else {
            setIsDisableBtnSend(false);
        }
    }, [messageValue]);

    const onChangeInputTextMessage = (value) => {
        setIsDisableBtnSend(Utils.isEmptyString(value.trim()))
        setMessageValue(value)
    }

    const onEnterTextInput = e => {
        if (e.key === 'Enter' && !e.shiftKey) {
            onSendMessage()
        }
    };

    const onSendMessage = async () => {
        if (!Utils.isEmptyString(messageValue?.trim())) {
            const newMessage = buildLiveChatMessageFromMe(messageValue);

            setMessages(prev => [...prev, newMessage]);
            setMessageValue('');

            if (!isModePreview) {
                let sendMsgResult = await postMessageLiveChat(
                    API,
                    newMessage,
                    supportThreadId,
                    affiliationOrganization,
                    supportTicketId,
                    setSentMessageList
                );
                if (!sendMsgResult) {
                    setMessages((prev) =>
                        prev.filter((msg) => msg.id !== newMessage.id)
                    );
                }
            }
        }
        setIsDisableBtnSend(true);
    }; 

    const handlePostImageFileOnChange = (event) => {
        let file = event.target.files[0];
        if (file) {
            let currentTime = new Date()
            let keyFileAtS3 = `${affiliationOrganization}/ticket/${supportTicketId}/chatThread/${supportThreadId}/${currentTime.getTime()}/${file.name}`;
            let progress = isModePreview ? 100 : 0
            let fileUpload = { file: file, progress: progress, status: true, key: keyFileAtS3, fileSize: file.size  };
            setFileUploadList(prev => [...prev,fileUpload]);
            let isImage = file && file['type'].split('/')[0] === 'image';
            let postType = isImage ? Constant.POST_TYPE.IMAGE : Constant.POST_TYPE.FILE
            let uploadFileMessage = BuildFieldUploadMessage(keyFileAtS3,file.name,true,0,postType,file.size);
            setMessages(prev =>[...prev,uploadFileMessage])
            event.target.value = '';
            if (!isModePreview) {
                onSubmitUploadFile(
                    file,
                    API,
                    affiliationOrganization,
                    affiliationProject,
                    supportTicketId,
                    supportThreadId,
                    `anonymous_${supportThreadId?.substr(14, 44)}`,
                    setFileUploading,
                    setFileUploadList,
                    keyFileAtS3,
                    fileUpload,
                    postType
                );
            }
        }
    };

    // const isShowCheckboxSendDoneByCustomer = () => {
    //     return true
    // }
    // const handleChangeSendDoneByCustomer = (e) => {
    //     let newValue = e.target.checked;
    //     setIsSendDone(newValue ? true : false); 
    // }

    return (
        <div className="formChat-wrap">
            <div className="formChat">
                <div className="groupForm-chat">
                    <div className="group-fild">
                        <div className="formField" data-cy="chat-form-input-field">
                            <TextField
                                name="chatbotName"
                                className="form-control"
                                variant="outlined"
                                // id="chatInput"
                                autoComplete="off"
                                value={messageValue}
                                defaultValue={messageValue}
                                onChange={e => onChangeInputTextMessage(e.target.value)}
                                onKeyPress={onEnterTextInput}
                                multiline={true}
                                placeholder="あなたのメッセージ..."
                            />
                        </div>

                        <div className="group-fildBtn" style={{ maxWidth: '40px' }}>
                            <div className="icon-tools">
                                <input
                                    accept="*"
                                    className="upload"
                                    id={`icon-button-photo`}
                                    type="file"
                                    onChange={handlePostImageFileOnChange}
                                />
                                <label htmlFor={`icon-button-photo`}>
                                    <IconButton
                                        className="itemTools"
                                        aria-label="upload picture"
                                        component="span"
                                    >
                                        <img src="/assets/image/icon-fileUpload.svg" alt="" />
                                    </IconButton>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="groupBtn-send">
                        <IconButton className="btnSend" disabled={isDisableBtnSend} onClick={(e)=>{onSendMessage()}}>
                            <img className={`send-message-icon-${isDisableBtnSend ? 'disable' : 'enable'}`} src="/assets/image/icon-send.svg" alt="" />
                        </IconButton>
                    </div>
                </div>
                {/* {isShowCheckboxSendDoneByCustomer() &&
                <div className='send-msg-by-customer'>
                    <input
                        type="checkbox"
                        id={`checkbox-send-msg-by-customer`}
                        defaultChecked={isSendDone ? true : false}
                        checked={isSendDone ? true : false}
                        className="send-msg-by-customer-checkbox"
                        onClick={e => handleChangeSendDoneByCustomer(e)}
                        // disabled={isDisableInputChat()}
                    />
                    <label
                        className="label-search-pdf"
                        htmlFor={`checkbox-send-msg-by-customer`}
                    >
                        {I18n.get('LABEL-CUSTOMER-TO-CHANGE_COMPLETE-STATUS')}
                    </label>
                </div>
            } */}
            </div>
        </div>
    );
}
